import React from 'react'
import ContentWrapper from '../ContentWrapper'
import {
  StyledMastheadBanner,
  StyledMastheadBannerWrapper,
  StyledMastheadBannerHeading,
  StyledMastheadBannerMessage,
  StyledMastheadBannerIcon,
} from './MastheadBanner.styles'
import { MastheadBannerProps } from './MastheadBanner.types'

export const MastheadBanner: React.FunctionComponent<MastheadBannerProps> = ({
  variant,
  title,
  alert: { link, message } = {
    link: '/',
    message: '',
  },
  className,
  id,
}) => (
  <StyledMastheadBanner
    aria-labelledby={id}
    className={className} 
    variant={variant}
  >
    <ContentWrapper>
      <StyledMastheadBannerWrapper
        href={link}
        target="_self"
      >
        <StyledMastheadBannerHeading id={id}>{title}</StyledMastheadBannerHeading>
        <StyledMastheadBannerMessage>{message}</StyledMastheadBannerMessage>
        <StyledMastheadBannerIcon />
      </StyledMastheadBannerWrapper>
    </ContentWrapper>
  </StyledMastheadBanner>
)

MastheadBanner.displayName = 'MastheadBanner'
